import { render, staticRenderFns } from "./form-item-attrs.vue?vue&type=template&id=9908097e&"
import script from "./form-item-attrs.vue?vue&type=script&lang=js&"
export * from "./form-item-attrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports